const ShareableArtifactTypes = {
  QUESTION: "question",
  SEGMENT: "segment",
  DASHBOARD: "dashboard",
  COMPOUND_SCORE: "compound_score",
  SCORE_TABLE: "score_table",
  DEEP_PROFILE: "deep_profile",
  TIMEVIEW: "timeview",
  CROSSTAB: "crosstab",
} as const;

export default ShareableArtifactTypes;
